import styled from "styled-components"
import Text from "../atoms/Text"
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

const CardWrapper =styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border-radius: 10px;
  padding: 20px 16px;
  position: relative;
 box-shadow: 0 1px 4px rgba(0,0,0,0.1);
`
const PlayButton = styled.button`
  position: absolute;
  right: 16px;
  top: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
`
const VolumeIcon = styled(VolumeUpIcon)`
  color: ${(props) => props.theme.colors.text.accent};
`
const ImageWrapper = styled.div`
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const Card = ({ card }) => {
  let audio = null;

  const handlePlay = () => {
    // 이미 재생 중이면 무시
    if (audio && !audio.paused) return;
    // 새로운 오디오 객체 생성
    audio = new Audio(card.audioUrl);
    // 오디오 종료 후 객체 초기화
    audio.addEventListener("ended", () => {
      audio = null;
    });
    audio.play();
  };

  return (
    <CardWrapper>
      <PlayButton onClick={handlePlay}>
        <VolumeIcon sx={{ fontSize:32 }}/>
       </PlayButton>
      <ImageWrapper>
        <Image src={card.imageUrl} alt={card.name} />
      </ImageWrapper>
      <Text variant="headline1" weight="bold">{card.name}</Text>
    </CardWrapper>
  )
}

export default Card
